<template>
  <section class="ViewScheme">
    <div class="ViewScheme__title app-main-title">{{ title }}</div>

    <div class="ViewScheme__desc app-main-description">
      {{ desc }}
    </div>
    <ul class="ViewScheme__list">
      <li class="ViewScheme__list-item" v-for="(item, ind) in list" :key="ind">
        <span>{{ item }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'ViewScheme',
  components: {},
  props: {
    title: String,
    desc: String,
    list: Array,
  },
};
</script>

<style lang="scss">
.ViewScheme {
  &__list-item {
    position: relative;
    padding-right: 10px;
    padding-left: 10px;
    font-size: rem(18);
    font-weight: 500;
    line-height: 1.2;

    @include media-lg() {
      font-size: rem(16);
    }

    @include media-sm() {
      font-size: rem(14);
    }

    @include media-xs() {
      width: 100%;
      padding-left: 40px;

      &:not(:last-child) {
        margin-bottom: 25px;
      }
    }

    @include media-xs('up') {
      padding-top: rem(42);

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
        text-align: right;

        &::before {
          right: 0;
          left: initial;
        }
      }
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: rem(24);
      height: rem(24);
      content: '';
      background: #fff;
      border: solid rem(6) #02b55f;
      border-radius: 50%;

      @include media-xs('up') {
        transform: translateY(-50%);
      }
    }
  }

  &__title {
    margin-bottom: rem(10);
  }

  &__desc {
    margin-bottom: rem(60);

    @include media-xs() {
      margin-bottom: 30px;
    }
  }

  &__list {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin: 0;
    list-style: none;

    @include media-xs() {
      flex-wrap: wrap;

      &::before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 11px;
        display: block;
        width: 2px;
        height: 100%;
        margin-bottom: rem(40);
        content: '';
        background: #02b55f;
      }
    }

    @include media-xs('up') {
      &::before {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 2px;
        margin-bottom: rem(40);
        content: '';
        background: #02b55f;
      }
    }
  }
}
</style>
